import Manager from "./src/Manager";
import TextField from "./src/Fields/TextField";
import SelectField from "./src/Fields/SelectField";
import TextAreaField from "./src/Fields/TextAreaField";
import CheckboxGroupField from "./src/Fields/CheckboxGroupField";
import CheckboxField from "./src/Fields/CheckboxField";
import DateField from "./src/Fields/DateField";
import EmailField from "./src/Fields/EmailField";
import FileField from "./src/Fields/FileField";
import HiddenField from "./src/Fields/HiddenField";
import NumberField from "./src/Fields/NumberField";
import RadioGroupField from "./src/Fields/RadioGroupField";
import PasswordField from "./src/Fields/PasswordField";
import GoogleRecaptchaField from './src/Fields/Services/GoogleRecaptchaField'
import PhoneField from "./src/Fields/PhoneField";

export const FormsManager = new Manager();

FormsManager.registerFieldType(CheckboxField)
FormsManager.registerFieldType(CheckboxGroupField)
FormsManager.registerFieldType(DateField)
FormsManager.registerFieldType(EmailField)
FormsManager.registerFieldType(FileField)
FormsManager.registerFieldType(HiddenField)
FormsManager.registerFieldType(NumberField)
FormsManager.registerFieldType(RadioGroupField)
FormsManager.registerFieldType(SelectField)
FormsManager.registerFieldType(TextAreaField)
FormsManager.registerFieldType(TextField)
FormsManager.registerFieldType(PasswordField)
FormsManager.registerFieldType(GoogleRecaptchaField)
FormsManager.registerFieldType(PhoneField)
